export default __webpack_public_path__ + "static/media/DinosaurCollection.fb075329.PNG";